// Check for document to prevent error with pre-rendering.
const Cookies = self.document ? require('cookies-js') : { set() {} };

const tourCurrencyDropdown = '#tour_booking_area select#booking_currency';

const CurrencyService = {
  changeCurrency(currency) {
    Cookies.set('currency', currency);

    if (
      window._tourView &&
      window._tourView.$el.find(tourCurrencyDropdown).val() !== currency
    ) {
      window._tourView.$el.find(tourCurrencyDropdown).val(currency);
      window._tourView.recalculatePrices();
    } else if (window.AR && window.AR.Views && window.AR.Views.Search) {
      window.location.reload();
    }
  },
};

export default CurrencyService;
